import {
  Box,
  ColorInput,
  Field,
  FieldControl,
  FieldIcon,
  FieldLabel,
} from "@prismicio/editor-ui"
import type { ColorContent } from "@prismicio/types-internal/lib/content"
import type { Color as ColorT } from "@prismicio/types-internal/lib/customtypes"

import { getFieldLabel, getFieldPlaceholder } from "../utils"

interface Props {
  id: string
  field: ColorT
  content?: ColorContent
  onContentChange: (content?: ColorContent) => void
}

export function ColorField(props: Props) {
  const { id, field, content, onContentChange } = props

  return (
    <Field>
      <FieldIcon name="colorLens" />
      <FieldLabel id={id}>{getFieldLabel(field)}</FieldLabel>
      <FieldControl>
        <Box padding={{ left: 4 }} alignItems="center">
          <ColorInput
            onValueChange={(newValue) =>
              onContentChange(updateContent(newValue))
            }
            value={content?.value}
            aria-labelledby={id}
            placeholder={getFieldPlaceholder(field)}
          />
        </Box>
      </FieldControl>
    </Field>
  )
}

function updateContent(value?: string): ColorContent | undefined {
  return value === undefined
    ? undefined
    : { __TYPE__: "FieldContent", type: "Color", value: value }
}
